import axios from 'axios';

document.addEventListener( 'DOMContentLoaded', function ( event ) {
	event.preventDefault();

	const form = document.querySelector( 'form.radevs-contact-form' );

	if ( ! form ) return;

	const email = form.querySelector( 'input[name=email]' );
	const name = form.querySelector( 'input[name=name]' );
	const subject = form.querySelector( 'input[name=subject]' );
	const message = form.querySelector( 'textarea[name=message]' );
	const position = form.querySelector( 'input[name=position]' );

	const submit = form.querySelector( 'button[type=submit]' );
	const error = form.querySelector( 'p.is-error' );

	const sendToInput = form.querySelector( 'input[name=mail_send_to]' );
	const sendTo = sendToInput.value;

	sendToInput.remove();

	if ( submit ) {
		submit.addEventListener( 'click', function ( event ) {
			event.preventDefault();

			if ( typeof window.submitButtonDisableTimeout !== 'undefined' ) {
				clearTimeout( window.submitButtonDisableTimeout );
			}

			const data = {
				email: email.value,
				name: name.value,
				subject: subject.value,
				message: message.value,
				position: position.value,
				sendTo: sendTo,
			};

			const request = sendPostRequest( data, () => {
				error.style.color = 'black';
				error.style.display = 'block';
				error.textContent = translate( 'Відбувається запит...' );

				submit.disabled = true;
			} );

			request.then( async ( response ) => {
				if ( typeof response.data.success === 'boolean' ) {
					const success = response.data.success;

					error.style.color = success ? 'green' : 'red';

					if ( success ) {
						submit.disabled = true;
						clearForm( form );
					} else {
						submit.disabled = false;
					}
				}

				if ( response.data.data.message ) {
					error.textContent = response.data.data.message;
				}

				window.submitButtonDisableTimeout = setTimeout( () => {
					error.style.display = 'none';
				}, 5000 );
			} );
		} );
	}
} );

async function sendRequest( params, beforeSend = null ) {
	if ( beforeSend ) {
		beforeSend();
	}

	params.action = 'contactForm';
	const url = window.location.origin + '/wp-admin/admin-ajax.php';
	const urlObject = new URL( url );
	urlObject.search = new URLSearchParams( params );

	return await axios.get( urlObject.toString() );
}

async function sendPostRequest( params, beforeSend = null ) {
	if ( beforeSend ) {
		beforeSend();
	}

	params.action = 'contactForm';
	const url = '/wp-admin/admin-ajax.php?action=contactForm';

	return await axios.post( url, JSON.stringify( params ) );
}

function translate( string ) {
	if ( typeof window.contact_form_translations === 'object' ) {
		if ( typeof window.contact_form_translations[ string ] === 'string' ) {
			return window.contact_form_translations[ string ];
		}
	}

	return string;
}

function clearForm( form ) {
	const email = form.querySelector( 'input[name=email]' );
	const name = form.querySelector( 'input[name=name]' );
	const subject = form.querySelector( 'input[name=subject]' );
	const message = form.querySelector( 'textarea[name=message]' );
	const position = form.querySelector( 'input[name=position]' );

	email.value = null;
	name.value = null;
	subject.value = null;
	message.value = null;
	position.value = null;
}
